import React from "react";
import RightPanel from "./RightPanel";
import LeftPanel from "./LeftPanel";

export default function MenuV2() {
    return (
        <div className="styles_MenuV2__Dqzo5">
            <div className="styles_MenuV2Wrapper__Q3ik_">
                <div className="styles_SubMenuContainer__rKcIG">
                    <LeftPanel />
                    <RightPanel />
                </div>
            </div>
        </div>
    );
}

/* ================= ITEM ================= */

